"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => ({
  radioItem: {
    marginBottom: 12,
    '&.checked': {
      '& $icon': {
        color: theme.radio.iconActiveColor
      },
      '& $label': {
        color: theme.radio.textActiveColor
      }
    },
    '&.hidden': {
      display: 'none'
    },
    '&.disabled, &.checked.disabled': {
      '& $icon': {
        color: theme.radio.iconDisabledColor
      },
      '& $label': {
        color: theme.radio.textDisabledColor,
        '&:hover': {
          cursor: 'default'
        }
      },
      '& $input:hover': {
        cursor: 'default'
      }
    },
    '&:last-child': {
      marginBottom: 0
    }
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    zIndex: 0
  },
  input: {
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
    cursor: 'inherit',
    pointerEvents: 'all',
    opacity: 0,
    position: 'absolute',
    zIndex: 2,
    width: 16,
    height: 16,
    left: 0,
    top: '50%',
    marginTop: -8,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  icon: {
    color: theme.radio.iconColor,
    flex: '0 0 auto'
  },
  label: {
    marginLeft: 8,
    color: theme.radio.textColor,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  children: {
    display: 'block',
    marginTop: 8,
    paddingLeft: 24
  }
});

exports.default = _default;